import { call, put, takeLatest } from "redux-saga/effects";
import { actions } from "./slice";
import * as APIS from "../../../../../services/apis";

export function* handleFetchCompanyBillingAddress({ payload }) {
  try {
    const res = yield call(APIS.fetchBillingAddressForCompany, payload);
    const { data } = res;
    yield put(actions.fetchCompanyBillingAddressSuccess(data));
  } catch (err) {
    yield put(actions.fetchCompanyBillingAddressFailure(err?.response?.data));
  }
}

export function* handleFetchTotalBillingAddresses({ payload }) {
  try {
    const res = yield call(APIS.fetchBillingAddressForCompany, payload);
    const { data } = res;
    yield put(actions.fetchTotalBillingAddressesSuccess(data));
  } catch (err) {
    yield put(actions.fetchTotalBillingAddressesFailure(err?.response?.data));
  }
}
export function* handleFetchCompanyDetails({ payload }) {
  try {
    const res = yield call(APIS.fetchCompanyDetails, payload);
    const { data } = res;
    yield put(actions.fetchCompanyDetailsSuccess(data));
  } catch (err) {
    yield put(actions.fetchCompanyDetailsFailure(err?.response?.data));
  }
}

export function* handleFetchCountries({ payload }) {
  try {
    const res = yield call(APIS.fetchAllCountries, payload);
    const { data } = res;
    yield put(actions.fetchCountriesSuccess(data));
  } catch (err) {
    yield put(actions.fetchCountriesFailure(err?.response?.data));
  }
}

export function* handleFetchStates({ payload }) {
  try {
    const res = yield call(APIS.fetchAllStatesByCountryId, payload);
    const { data } = res;
    yield put(actions.fetchStatesSuccess(data));
  } catch (err) {
    yield put(actions.fetchStatesFailure(err?.response?.data));
  }
}

export function* handleFetchCities({ payload }) {
  try {
    const res = yield call(APIS.fetchAllCitiesByStateId, payload);
    const { data } = res;
    yield put(actions.fetchCitiesSuccess(data));
  } catch (err) {
    yield put(actions.fetchCitiesFailure(err?.response?.data));
  }
}
export function* handleAddBillingAddress({ payload }) {
  try {
    const res = yield call(APIS.addAddress, payload);
    const { data } = res;
    yield put(actions.addBillingAddressSuccess(data));
    if (payload.onSuccess) payload.onSuccess();
  } catch (err) {
    yield put(actions.addBillingAddressFailure(err?.response?.data));
    payload.onFailure();
  }
}
export function* handleUpdateBillingAddress({ payload }) {
  try {
    const res = yield call(APIS.updateAddress, payload);
    const { data } = res;
    yield put(actions.updateBillingAddressSuccess(data));
    payload.onSuccess();
  } catch (err) {
    yield put(actions.updateBillingAddressFailure(err?.response?.data));
    payload.onFailure();
  }
}
/**
 * Root saga manages watcher lifecycle
 */
export function* companyBillingAddressSaga() {
  yield takeLatest(
    actions.fetchCompanyBillingAddress.type,
    handleFetchCompanyBillingAddress
  );
  yield takeLatest(actions.fetchCompanyDetails.type, handleFetchCompanyDetails);
  yield takeLatest(actions.fetchCountries.type, handleFetchCountries);
  yield takeLatest(actions.fetchStates.type, handleFetchStates);
  yield takeLatest(actions.fetchCities.type, handleFetchCities);
  yield takeLatest(actions.addBillingAddress.type, handleAddBillingAddress);
  yield takeLatest(
    actions.updateBillingAddress.type,
    handleUpdateBillingAddress
  );
  yield takeLatest(
    actions.fetchTotalBillingAddresses,
    handleFetchTotalBillingAddresses
  );
}
